import React from 'react';
import FormLayout from '../FormLayout';
import FormLayoutField from '../FormLayoutField';
import imagePlaceholder from '../../assets/images/imagePlaceholder.webp';
import i18n from '../../locales/i18n';

/** Display-only image field (upload or settings library). */
class StaticImageField extends FormLayoutField {

    constructor(properties) {
        const defaults = StaticImageField.getDefaultOptions();
        const content = properties?.content && typeof properties.content === 'object'
            ? properties.content
            : {};

        super({
            ...defaults,
            ...properties,
            content: { ...defaults.content, ...content },
        });

        this.type = FormLayout.STATIC_IMAGE;
    }

    static getDefaultOptions() {
        const properties = {
            ...super.getDefaultOptions(),
            content: {
                source: 'upload',
                rfc2397_data: null,
                library_type: null,
            },
        };
        return properties;
    }

    getHandledOptions() {
        return [
            FormLayout.OPTION_WIDTH,
            FormLayout.OPTION_STATIC_IMAGE,
        ];
    }

    resolveSrc(setting, lang) {
        const source = this.content?.source || 'upload';
        if (source === 'library') {
            const type = this.content?.library_type;
            if (type && setting?.findImage) {
                const image = setting.findImage(type, lang);
                if (image?.rfc2397_data) {
                    return image.rfc2397_data;
                }
            }
            // Snapshot stored at edit time for public embeds without settings.
            return this.content?.rfc2397_data || null;
        }
        return this.content?.rfc2397_data || null;
    }

    renderImage(props) {
        const { lang, setting } = props;
        const src = this.resolveSrc(setting, lang);
        return (
            <div className="field-wrapper form-group text-left">
                <img
                    src={src || imagePlaceholder}
                    alt={i18n.t('forms.static_image_alt')}
                    style={{ maxWidth: '100%', height: 'auto' }}
                />
            </div>
        );
    }

    getPreview(props) {
        return this.renderImage(props);
    }

    getLabel(_props) {
        return null;
    }

    getInput(props) {
        return this.renderImage(props);
    }

    getIcon() {
        return 'picture-o';
    }
}

export default StaticImageField;
